<template>
  <div>
    <div class="document">
      <div class="header profile-header">
        ID Manager
      </div>
    <div class="no-bottom-border">
      <es-tabs :tabs="availableTabs" ref="tabs"></es-tabs>
    </div>
    </div>
    <router-view name="idManagerSelection"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';
import EsTabs from '@/components/EsTabs.vue';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    EsTabs,
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      {
        isAvailable: true,
        name: 'PIOverview',
        label: 'OVERVIEW',
      },
      {
        isAvailable: this.hasModule('PRSID:IDENT:DUPLICATES:VIEW'),
        name: 'PIDuplicateSearch',
        query: { search: 'session' },
        label: 'DUPLICATE SEARCH',
      },
      {
        isAvailable: this.hasModule('PRSID:IDENT:RETIREID'),
        name: 'PIRetireMerge',
        label: 'RETIRE/MERGE ID',
        forceActive: false,
      },
      {
        isAvailable: this.hasModule('PRSID:IDENT:SHAREDIDS:VIEW'),
        name: 'PISharedId',
        label: 'SHARE ID SEARCH',
      },
      {
        isAvailable: this.hasModule('PRSID:IDENT:SEPARATEID'),
        name: 'PISplitId',
        label: 'SPLIT ID',
        forceActive: this.$route.path.includes('splitIdDetails'),
      },
    ];
    this.syncForcedActiveTabs(this.$route);
    this.setBreadcrumb([
      {
        text: 'ID Manager',
        to: {},
      },
    ]);
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    availableTabs() {
      return this.tabs.filter(tab => tab.isAvailable);
    },
  },
  watch: {
    $route(to) {
      this.syncForcedActiveTabs(to);
    },
  },
  methods: {
    syncForcedActiveTabs(route) {
      const isRetireMergeDetails = route.path.includes('retireMergeIdDetails');
      const isSplitIdDetails = route.path.includes('splitIdDetails');

      this.tabs = this.tabs.map((tab) => {
        if (tab.name === 'PIRetireMerge' && this.hasModule('PRSID:IDENT:RETIREID')) {
          return {
            ...tab,
            forceActive: isRetireMergeDetails,
          };
        }

        if (tab.name === 'PISplitId' && this.hasModule('PRSID:IDENT:SEPARATEID')) {
          return {
            ...tab,
            forceActive: isSplitIdDetails,
          };
        }

        return tab;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .profile-header
    font-size: 20px
    color: #212529
    text-align: left
    padding: 0.5rem 0 0.5rem 1.5rem
  .tabs
    padding: 0rem 1rem
</style>
